<template>
  <div class="filter-wrap -dropdown" v-if="filteredValues.length && showFilterWrap" :class="{'-open': openFilter}">
    <div class="filters__filter">
      <div class="filter__title" @click="openFilter = !openFilter">
        <span class="heading">{{ title }}</span>
      </div>
      <div class="filter__options">
        <CheckboxField
            :identifier="type + '-' + index"
            :label="option.value"
            :value="{searchTerm: option.searchTerm, value: option.value}"
            v-model="selectedFilters"
            @handleTracking="newVal => handleFilterTracking(newVal, title, option.value, type)"
            v-show="showAll || index < 3"
            v-for="(option, index) in filteredValues" :key="'filter-' + type + '-checkbox-' + index"/>
      </div>
      <div class="filter__link" v-if="filteredValues.length > 3 && openFilter">
        <div class="link -link-alpha">
          <span @click="showAll = !showAll" v-if="!showAll">{{ $t('list.filter.showMore') }}</span>
          <span @click="showAll = !showAll" v-if="showAll">{{ $t('list.filter.showLess') }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-wrap -range -dropdown" :class="{'-open': openFilter}" v-else-if="filterType === 'range' && values[1].max && props.filterListType === 'List'">
    <div class="filters__filter">
      <div class="filter__title" @click="openFilter = !openFilter">
        <span class="heading">{{ title }}</span>
      </div>
      <div class="filter__options">
        <RangeField :minMax="values"
                    :identifier="filterType + '-filter'"
                    :selectedRange="filterStore.rangeFilters[type]"
                    @handleTracking="newVal => handleFilterTracking(newVal, title, filterStore.rangeFilters[type].options[1].max, type)"
                    @update:modelValue="triggerFilter()"
                    @update:modelValueMax="newVal => filterStore.rangeFilters[type].options[1].max = newVal"
                    @update:modelValueMin="newVal => filterStore.rangeFilters[type].options[0].min = newVal">
        </RangeField>

      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, defineEmits, ref} from 'vue'
import CheckboxField from '@/components/form/CheckboxField.vue'
import RangeField from '@/components/form/RangeField.vue'
import { useFilterStore } from '@/stores/filter'
import { useGlobalStore } from '@/stores'
import {useMatingPairsFilterStore} from "@/stores/matingPairsFilter";
const globals = useGlobalStore()

const filterStore = computed(() =>
{
  if (props.filterListType === 'List')
  {
    return useFilterStore()
  } else {
    return useMatingPairsFilterStore()
  }
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
  filterType: {
    type: String,
    default: ''
  },
  filterListType: {
    type: String,
    default: 'List'
  },
  values: {
    type: Array,
    default: function () {
      return []
    }
  },
  modelValue: {
    type: Array,
    default: function () {
      return []
    }
  }
})

const openFilter = ref(true)
const showAll = ref(false)

const emit = defineEmits(['update:modelValue'])

const filteredValues = computed(() =>
{
  let filteredVal = props.values
  filteredVal.sort((a,b) => a.priority - b.priority)
  return filteredVal.filter(item => item.doc_count > 0)
})

const showFilterWrap = computed(() =>
{
  return props.filterType !== 'checkbox' || !(filteredValues.value.length <= 1 && props.modelValue.length === 0)
})

const selectedFilters = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  }
})

function handleFilterTracking (isChecked, title, value, type)
{
  if (isChecked && !isChecked.value && window.dataLayer)
  {
    window.dataLayer.push({
      'filter-category': title,
      'filter-value': value,
      'filter-type': type,
      'event': 'filter-category-event'
    })
  } else if (props.filterType && window.dataLayer)
  {
    window.dataLayer.push({
      'filter-category': title,
      'filter-value': value,
      'filter-type': type,
      'event': 'filter-category-event'
    })
  }
}

function triggerFilter ()
{
  globals.filter()
}
</script>

